import axiosInstance from "./axiosInstance";

/* ================= GET ================= */
export const getPublicSuport = async () => {
  try {
    const res = await axiosInstance.get("/api/admin-suport/suports/public");
    return {
      success:res.data.success || true,
      data: res.data.data,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to fetch suports",
    };
  }
};